import axios from "axios";
import history from "../history";
import api from "./apis";

import {
  LOADED,
  LOADING,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  VALIDATION_ERROR,
} from "./types";

export const createNewRole = (data) => async (dispatch) => {
  dispatch({ type: LOADING });
  const access = {
    user_management: data.user_management ? data.user_management : false,
    client_management: data.client_management ? data.client_management : false,
    message_management: false, //data.message_management ? data.message_management : false,
    app_management: data.app_management ? data.app_management : false,
    code_management: data.code_management ? data.code_management : false,
    finance_management: data.finance_management
      ? data.finance_management
      : false,
    support_management: data.support_management
      ? data.support_management
      : false,
    setting_management: data.setting_management
      ? data.setting_management
      : false,
    report_management: data.report_management ? data.report_management : false,
    product_management: data.product_management
      ? data.product_management
      : false,
  };
  const object = {
    name: data.role,
    active: true,
    access,
  };

  try {
    const response = await api(localStorage.getItem("token")).post(
      "/user-management/role/create",
      { ...object }
    );

    if (response.status === 201) {
      dispatch({ type: LOADED });
      dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
      history.push("/roles");
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const getAssignableRoles = () => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await api(localStorage.getItem("token")).get(
      "/user-management/role/assignable"
    );

    dispatch({ type: LOADED });
    return response.data.roles;
    // dispatch({type: GET_ROLES, payload: response.data.roles})
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const getRoles = () => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await api(localStorage.getItem("token")).get(
      "/user-management/role/all"
    );

    dispatch({ type: LOADED });
    return response.data.roles;
    // dispatch({type: GET_ROLES, payload: response.data.roles})
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};
export const getRoleById = (id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await api(localStorage.getItem("token")).get(
      `/user-management/role/detail?role=${id}`
    );

    dispatch({ type: LOADED });
    return response.data.role;
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const updateRole = (data, roleId) => async (dispatch) => {
  dispatch({ type: LOADING });
  const access = {
    user_management: data.user_management ? data.user_management : false,
    client_management: data.client_management ? data.client_management : false,
    message_management: false,
    // message_management : data.message_management ? data.message_management : false,
    app_management: data.app_management ? data.app_management : false,
    code_management: data.code_management ? data.code_management : false,
    finance_management: data.finance_management
      ? data.finance_management
      : false,
    support_management: data.support_management
      ? data.support_management
      : false,
    setting_management: data.setting_management
      ? data.setting_management
      : false,
    product_management: data.product_management
      ? data.product_management
      : false,
    report_management: data.report_management ? data.report_management : false,
  };
  const object = {
    role: roleId,
    name: data.role,
    active: data.active,
    remark: data.remark,
    access,
  };
  try {
    const response = await api(localStorage.getItem("token")).patch(
      "/user-management/role/update",
      { ...object }
    );

    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Role is updated Successfully",
      });
      dispatch({ type: LOADED });
      history.push("/roles");
    } else {
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const updateRoleAuth = (role, active) => async (dispatch) => {
  dispatch({ type: LOADING });

  const object = {
    role: role,
    active: active,
  };
  dispatch({ type: LOADED });

  try {
    const response = await api(localStorage.getItem("token")).patch(
      "/user-management/role/active",
      { ...object }
    );

    if (response.status === 201) {
      dispatch({ type: LOADED });
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Role authentication is updated succesfully",
      });

      return response.status;
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const deleteRole = (role, data) => async (dispatch) => {
  dispatch({ type: LOADING });

  try {
    const response = await axios(
      `${process.env.REACT_APP_API_BASE_URL}/sailor/v1/user-management/role/delete`,
      {
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          role: role,
          remark: data.remark,
        },
        method: "delete",
      }
    );

    if (response.status === 201) {
      dispatch({ type: LOADED });
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "User is deleted succesfully",
      });

      return response.status;
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};
